<template>
  <div class="profile-info__rank">
    <svg
      v-for="(v, i) in Number(count)"
      :key="i"
      x="0px"
      y="0px"
      viewBox="0 0 256 256"
      enable-background="new 0 0 256 256"
      xml:space="preserve"
    >
      <g>
        <defs>
          <path
            id="SVGID_1_"
            d="M218.5,218.5c-50,50-131,50-181,0c0,0,0,0,90.5-90.5L218.5,218.5z"
          />
        </defs>
        <clipPath id="SVGID_2_">
          <use xlink:href="#SVGID_1_" overflow="visible" />
        </clipPath>
        <path
          clip-path="url(#SVGID_2_)"
          d="M128,256C57.3,256,0,198.7,0,128c0,0,0,0,128,0V256z"
        />
        <line
          clip-path="url(#SVGID_2_)"
          fill="none"
          x1="256"
          y1="0"
          x2="256"
          y2="0"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "HeaderProfileRank",

  props: {
    count: {
      type: [Number, String],
      default: () => 0
    }
  }
};
</script>
